var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';








const Card = ({ title, children, className, color = 'default' }) => {
  let headerColor;

  switch (color) {
    case 'yellow':
      headerColor = 'bg-yellow-100 text-yellow-800';
      break;
    default:
      headerColor = 'bg-gray-50 text-primary-700';
  }

  return /*#__PURE__*/(
    _jsx("div", { className: `border rounded-md border-gray-50 shadow-sm ${className}` }, void 0, /*#__PURE__*/
    _jsx("div", { className: `block w-full font-semibold text-base p-4 ${headerColor}` }, void 0, title), /*#__PURE__*/
    _jsx("div", { className: "p-4" }, void 0, children)
    ));

};

export { Card };